import React, { useState } from "react";

const usePagination = (data, itemsPerPage) => {
  const [currentPage, setCurrentPage] = useState(1);
  const maxPage = Math.ceil(data.length / itemsPerPage);
  const currentData = () => {
    const begin = (currentPage - 1) * itemsPerPage;
    const end = begin + itemsPerPage;
    return data.slice(begin, end);
  }

  const jump = (page) => {
    const pageNumber = Math.max(1, page);
    if(maxPage === 0){
      setCurrentPage(Math.min(pageNumber, 1));
    }
    else {
      setCurrentPage(Math.min(pageNumber, maxPage));
    }
  }

  return { jump, currentData, currentPage, maxPage };
}

export default usePagination;
